import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import Image from "../hooks/useImage";
import useRenderBlocks from '../hooks/useRenderBlocks';
import SEO from "../components/SEO/SEO";
import useDecodeHtml from '../hooks/useDecodeHtml';
import { formatDate } from '../utils/formatDate';
import Wrapper from '../components/Wrapper/Wrapper';
import { usePreviewArticle } from '../api/fetchExampleData';

// Styled Components
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr; /* Due colonne */
  gap: 2em;
  align-items: flex-start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* Una colonna per dispositivi mobili */
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const Sidebar = styled.div`
  position: sticky;
  top: 20px;
  height: calc(100vh - 20px);
  overflow-y: auto;
  background-color: #ffffff;
  border-left: 1px solid #ddd;

  @media (max-width: 768px) {
    display: none; /* Nasconde la sidebar su dispositivi mobili */
  }
`;

const CategoryTag = styled.div`
  background-color: #cc0000;
  padding: 0.5em;
  color: white;
  max-width: fit-content;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;

  h3 {
    margin: 0;
  }
`;

const PreviewArticle = () => {
  const { id } = useParams(); // Usa l'ID per identificare l'articolo
  const decodeHtml = useDecodeHtml();

  // Usa il nuovo hook per recuperare l'articolo
  const { data: article} = usePreviewArticle(id);

  // Chiamare sempre il hook, anche con dati vuoti
  const renderedContent = useRenderBlocks(article?.blocks || []);
  return (
    <Wrapper>
      <SEO
        title={decodeHtml(article.title)}
        description={decodeHtml(article.excerpt)}
        image={article.image}
        url={`https://rossomotori.it/preview/${id}`}
      />
      <GridContainer>
        {/* Contenuto Principale */}
        <MainContent>
          <CategoryTag>
            <Link to={`/category/${article.categories[0].slug}`} style={{ textDecoration: 'none' }}>
              <h3>{decodeHtml(article.categories[0].name)}</h3>
            </Link>
          </CategoryTag>
          <h1 style={{ fontSize: '44px', fontWeight: '800', lineHeight: '52px', letterSpacing: '-0.55px', margin: '0.2em 0' }}>
            {decodeHtml(article.title || 'Titolo non disponibile')}
          </h1>
          <p style={{ fontStyle: 'italic' }}>{decodeHtml(article.excerpt)}</p>
          <figure className="content-block" style={{ marginTop: '1em' }}>
            <Image src={article.image} alt={article.title} width={'100%'} height={'100%'} />
            {article.caption && (
              <figcaption style={{ marginBottom: '1em', fontStyle: 'italic', color: '#454850' }}>
                {decodeHtml(article.caption)}
              </figcaption>
            )}
          </figure>
          <div style={{ display: 'flex', padding: '1em 0', alignItems: 'center' }}>
            <Link
              to={`/team/${article.author.name.replace(/\s+/g, '-').toLowerCase()}`}
              style={{ textDecoration: 'none' }}
            >
              <img
                src={article.author.avatar}
                alt={`${article.author.name}'s avatar`}
                style={{
                  borderRadius: '50%',
                  width: '80px',
                  height: '80px',
                }}
              />
            </Link>
            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '1em' }}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <p style={{ color: '#1C2029', fontSize: '21px', margin: 0 }}>Di:</p>
                <Link
                  to={`/team/${article.author.name.replace(/\s+/g, '-').toLowerCase()}`}
                  style={{ textDecoration: 'none' }}
                >
                  <p
                    style={{
                      fontWeight: 'bold',
                      fontSize: '21px',
                      color: '#1C2029',
                      margin: 0,
                      marginLeft: '5px',
                    }}
                  >
                    {article.author.name}
                  </p>
                </Link>
              </div>
              <p style={{ fontWeight: 'bold', fontSize: '16px', color: '#454850', margin: 0 }}>{formatDate(article.date)}</p>
            </div>
          </div>
          {renderedContent}
        </MainContent>
      </GridContainer>
    </Wrapper>
  );
};

export default PreviewArticle;
